module.exports = __webpack_public_path__ + "media/responsive/contact-mobile-0192e70c.jpg";